import type { PaletteColor } from '@mui/material/styles/createPalette';
import { black } from './colors';
import type { ColorPreset } from './index';

export const getPrimary = (_preset?: ColorPreset): PaletteColor => {
  return black;
};
